// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUserSchema {
  /** Аватар **/
  avatarUrl: string;
  /** Id пользователя realty **/
  id: number;
  /** Отображаемое имя **/
  name: string;
  /** Тип пользователя **/
  type: EType;
}

export enum EType {
  /** Застройщик **/
  'Builder' = 'builder',
  /** Поискун **/
  'Regular' = 'regular',
}
